import validate from "D:/W2/CDVM_V2/VM.Cms/node_modules/nuxt/dist/pages/runtime/validate.js";
export const globalMiddleware = [
  validate
]
export const namedMiddleware = {
  "password-change": () => import("D:/W2/CDVM_V2/VM.Cms/middleware/password-change.ts")
}